import axios from "axios";
import { BASE_URL, SHOP_URL } from "../../Landing/Components/Api/Api";
import { Button } from "react-bootstrap";
import { InputText } from "primereact/inputtext";
import DatePickerFormat from "../../Landing/Components/FormOptions/DatePickerFormat";

export function formatNumber(number) {
  const stringedNumber = number?.toString();
  if(typeof stringedNumber !== 'string') {
    console.warn('stringedNumber is not a string')
    return number;
  }
  const [intValue, floatValue] = stringedNumber.split(".");
  const result = floatValue ? intValue + "." + floatValue[0] : intValue;
  return parseFloat(result);
}
export const sendPostRequest = async (
  cmd,
  cmdLabel,
  cmdValue,
  requestData,
  onResponse
) => {
  console.log(cmdLabel, typeof cmdValue);
  try {
    const response = await axios.post(SHOP_URL, requestData, {
      headers: {
        cmd: cmd,
        token: cmdValue,
        // 'token':'123',
        "Content-type": "multipart/form-date",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const data = response?.data;
      onResponse(data);
    } else {
      throw new Error(`API request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw new Error(error.message);
  }
};
export const fetchData = async (
  cmdValue,
  requestData,
  onResponse,
  loadActions
) => {
  try {
    loadActions?.load();
    const response = await axios.post(BASE_URL, requestData, {
      headers: {
        cmd: cmdValue,
        "Content-type": "multipart/form-date",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const data = response?.data;
      onResponse(data);
      loadActions?.unload()
    } else {
      throw new Error(`API request failed with status: ${response.status}`);
    }
  } catch (error) {
    loadActions?.unload()
    throw new Error(error.message);
  }
};
export const fetchShopData = async (cmdValue, requestData, onResponse) => {
  try {
    const response = await axios.post(BASE_URL, requestData, {
      headers: {
        cmd: cmdValue,
        "Content-type": "multipart/form-date",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const data = response?.data;
      onResponse(data);
    } else {
      throw new Error(`API request failed with status: ${response.status}`);
    }
  } catch (error) {
    throw new Error(error.message);
  }
};



// Reusable filtering functions
export const getFilterButton = (option) => (
  <Button onClick={() => option.filterApplyCallback(option.filterModal)}>
    اعمال
  </Button>
);

export const getFilterSelect = (options, list, key, placeholder) => (
  <select
    id={key}
    name={key}
    defaultValue=""
    className="form-control"
    value={options.value} // Change this to use options.value
    onChange={(e) => options.filterCallback(e.target.value)}
  >
    <option value="" disabled>
      {placeholder}
    </option>
    {list?.map((item) => (
      <option key={item.value} value={item.value}>
        {item?.label}
      </option>
    ))}
  </select>
);

export const getFilterInputText = (options, placeholder) => (
  <InputText
    value={options.value}
    onChange={(e) => options.filterCallback(e.target.value)}
    placeholder={placeholder}
    className="p-column-filter"
  />
);

export const getFilterClearButton = (options) => (
  <Button
    type="button"
    icon="pi pi-times"
    className="btn btn-danger"
    onClick={options.filterClearCallback}
    severity="secondary"
  >
    حذف فیلتر
  </Button>
);

export const getFilterDate = (options, placeholder,watch,control) => (
  <div>
    <DatePickerFormat
      name={"from"}
      label={"از تاریخ:"}
      control={control}
      onChange={(date) =>
        options.filterCallback(
          JSON.stringify({ from: date, to: watch("to") })
        )
      }
    />
    <DatePickerFormat
      name={"to"}
      label={"تا تاریخ:"}
      control={control}
      onChange={(date) =>
        options.filterCallback(
          JSON.stringify({ from: watch("from"), to: date })
        )
      }
    />
  </div>
);